export default "__VITE_ASSET__B4A4otIw__"